import { render, staticRenderFns } from "./ClassMembers.vue?vue&type=template&id=dd66f494&scoped=true&"
import script from "./ClassMembers.vue?vue&type=script&lang=js&"
export * from "./ClassMembers.vue?vue&type=script&lang=js&"
import style0 from "./ClassMembers.vue?vue&type=style&index=0&id=dd66f494&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd66f494",
  null
  
)

export default component.exports